import {CanActivateFn, Router} from '@angular/router';
import {inject} from '@angular/core';
import {Navigate} from '../lib/navigate';
import {UserContextService} from '@ccp/services/app-context/user-context.service';

export const RegistrationGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const userContextService = inject(UserContextService);
  if (userContextService.currentUser$()?.isLogged) {
    // logged in so return false
    Navigate.GoToProductQrCodeRegistration(router, {queryParams: route.queryParams});
    return false;
  }
  return true;
};
